import React from "react";
import { BriefcaseBusiness } from "lucide-react";
import { usePortfolioContext } from "./PortfolioContext";

const EXPERIENCE_FIELDS = [
  {
    label: "Movies",
    name: "movieNames",
    placeholder: "Movie 1, Movie 2...",
  },
  {
    label: "Web Series",
    name: "webseriesNames",
    placeholder: "Web Series 1, Web Series 2...",
  },
  {
    label: "TV Shows",
    name: "tvShowNames",
    placeholder: "TV Show 1, TV Show 2...",
  },
  {
    label: "Short Films",
    name: "shortFilmNames",
    placeholder: "Short Film 1, Short Film 2...",
  },
  {
    label: "Advertisements",
    name: "adNames",
    placeholder: "Ad 1, Ad 2...",
  },
  {
    label: "Fashion Events",
    name: "fashionEventNames",
    placeholder: "Event 1, Event 2...",
  },
] as const;

const Experience: React.FC = () => {
  const { formData, setFormData } = usePortfolioContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="portfolio-tab-panel">
      <section className="portfolio-experience-card">
        <div className="portfolio-section-title portfolio-experience-title">
          <div className="portfolio-section-icon">
            <BriefcaseBusiness size={20} />
          </div>
          <div>
            <span>CAREER EXPERIENCE</span>
            <h2>Experience</h2>
            <p>
              List the projects you have worked on. Separate multiple names
              with commas.
            </p>
          </div>
        </div>

        <div className="portfolio-experience-form">
          <div className="portfolio-form-grid portfolio-form-grid-two">
            {EXPERIENCE_FIELDS.map((field) => (
              <label key={field.name}>
                <span>{field.label}</span>
                <input
                  type="text"
                  name={field.name}
                  value={(formData as any)[field.name]}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                />
              </label>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experience;
